import React from 'react';
import PropTypes from 'prop-types';

const ModalMobile = ({ id, title, onClose, data }) => {
  return (
<>
    <div className="fixed inset-0 z-50 flex justify-center items-center bg-black bg-opacity-50 ">
      <div className="bg-white p-8 rounded-lg shadow-lg w-[95%]">
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-lg font-bold">{title}</h2>
          <div className="flex space-x-2">
            <button className="w-3 h-3 bg-green-500 rounded-full cursor-pointer hover:bg-green-300 transition" onClick={() => onClose(id)}></button>
            <button className="w-3 h-3 bg-yellow-500 rounded-full cursor-pointer hover:bg-yellow-300 transition" onClick={() => onClose(id)}></button>
            <button
              className="w-3 h-3 bg-red-500 rounded-full cursor-pointer hover:bg-red-300 transition"
              onClick={() => onClose(id)}
            ></button>
          </div>
        </div>
        <div className="flex-1 overflow-y-auto">
          <div className="p-1 max-h-[400px]">
            {data}
          </div>
        </div>
      </div>
    </div>
</>
  );
};

ModalMobile.propTypes = {
  id: PropTypes.number.isRequired,
  title: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired,
  data: PropTypes.node.isRequired,
};

export default ModalMobile;
